<div
  style="background-image: url(../assets/img/prohibited-items-background.webp); background-size: cover; background-repeat: no-repeat;">

  <div class="shippn-homepage-container container">
    <div class="row">
      <div style="text-align: center;" class="col-md-12">
        <h1
          style="text-align: center;font-size: 40px;font-weight: bold;margin-bottom: 170px;color: white;margin-top: 170px;">
          Prohibited Items for International Shipping</h1>
      </div>
    </div>
  </div>

</div>

<div style="background-color: #222222">
  <div class="shippn-homepage-container container">
    <div style="padding-top: 50px;padding-bottom: 50px;" class="row">
      <div style="text-align: left;" class="col-md-12">
        <p style="color: #ffffff;font-size: 15px;font-weight: 300;margin-top: 20px;margin-bottom: 20px;">
          The most common question in shipping items internationally is " Which items are prohibited to ship
          internationally " <br>
          We in Shippn have put together guidelines for our top 50 country destinations.<br>
          <br>
          To find out specific details about the prohibited items in your country, please select your country from the
          list below.
        </p>
        <div class="prohibited-area-padding" style="background-color: #414141;border-radius: 10px;">
          <h6 style="color: white;">Select Country</h6>
          <div
            style="margin-top: 5px; margin-bottom: 5px;position: relative; background-color: #fff; border-radius: 5px;"
            class="select--wrapper">
            <i class="fas fa-chevron-down"
              style="position: absolute; right: 15px; top: 9px;float: right; color: #222222; border-radius: 32%; padding: 7px; font-size: 12px;"
              aria-hidden="true"></i>
            <select (change)="getProhibitedItems(selectedCountry)"
              style="-webkit-appearance: none;-moz-appearance: none;appearance: none; width: 100%; border-radius: 5px;height:40px;"
              [(ngModel)]="selectedCountry" class=" form-control-sm">
              <option value="" disabled selected>Select Country</option>
              <option value="{{country.code}}" *ngFor="let country of prohibitedCountriesActiveList">
                <span *ngIf="country.code != 'TR' && country.name != 'Turkey'">{{country.name}}</span>
                <span *ngIf="country.code == 'TR' || country.name == 'Turkey'" translate="no">Türkiye</span>
              </option>

            </select>
          </div>
        </div>
        <p style="color: #ffffff;font-size: 15px;font-weight: 300;margin-top: 20px;margin-bottom: 20px;">
          Here is the list of prohibited and restricted items. Before creating the order, please, make sure that the
          products you want to buy from abroad are not on the list below.
        </p>
        <h6 style="color: #fc7137;">List of prohibited and restricted items for international shipping</h6>
        <hr style="border-color: #fc7137;margin-top: 10px;margin-bottom: 10px;">

        <div class="prohibited-area" style="color: white;">

          <div *ngIf="!showInitialData">
            <div *ngIf="prohibitedItemsData.is_active === 1">
              <div class="prohibited-area-categories" *ngFor="let category of prohibitedItemsData['categories']">
                <h5>{{category.category}}</h5>
                <ul>
                  <li *ngFor="let item of category.items">
                    {{item}}
                  </li>
                </ul>
              </div>
            </div>

            <div *ngIf="prohibitedItemsData.is_active === 0">
              <p>
                There is currently no available data.
              </p>
            </div>
          </div>



          <div *ngIf="showInitialData">
            <h5>Prohibited items from international shipping:</h5>
            <ul>
              <li>One-of-a-kind/irreplaceable articles such as artwork valued over US$500,000 each</li>
              <li>Flammables with a flash point of 140 degrees Fahrenheit or less</li>
              <li>Auto parts with fluids in them</li>
              <li>Furs</li>
              <li>Pornography (whether in printed, film or digital format)</li>
              <li>Adult Toys</li>
              <li>Precious metals such as gold, silver and platinum in the form of bullion, coins or ingots</li>
              <li>Watches valued over US$1000</li>
              <li>Weapons and weapons accessories</li>
              <li>Bullion and money of every description such as (but without prejudice to the generality of this
                clause) cash, bank notes, coins, currency notes or currency of any kind</li>
              <li>Stamps (postage or revenue); vouchers; tokens; tickets of any kind; and credit, debit or cash cards
              </li>
              <li>Time-sensitive or critical written materials or documents including, but not limited to, bids and
                contract proposals</li>
              <li>Contraband including, but not limited to, illicit drugs and counterfeit goods</li>
              <li>Livestock, bloodstock and living animals</li>
              <li>Human remains</li>
              <li>Electronic cigarettes, accessories, flavors, e-liquids, and other vaping products.</li>
              <li>Alcoholic beverages.</li>
              <li>All Samsung Galaxy Note7 and Samsung Note7 devices</li>
              <li>Antiques, works of art, and fine art with an individual value of over $5,000.</li>
              <li>Illegal goods, such as counterfeit goods and narcotics.</li>
              <li>Biological Substances, Category B and Exempt Human or Animal Specimens.</li>
              <li>Military equipment, Tactical gear, Night-vision sights, and Bayonets.</li>
              <li>Dangerous/hazardous goods including but not limited to perfumes, aftershaves, aerosols, flammable
                substances, dry ice, biological substances, UN-classified dangerous goods, and any goods specified as
                such under International Air Transport Association regulations ("IATA"), the Agreement on Dangerous
                Goods by Road ("ADR") or International Maritime Dangerous Goods ("IMDG") regulations.</li>
              <li>Nail Polish.</li>
              <li>Jewellery, costume jewelry, watches, and objects constructed of precious metal and/or stones with a
                value over $4,000 per waybill</li>
              <li>Animal Products, non-domesticated (e.g. mother of pearl inlay, snakeskin watch band).</li>
              <li>Loose precious and semi-precious stones (cut or uncut, polished or unpolished).</li>
              <li>Plants, seeds, and agricultural products.</li>
              <li>Lottery Ticket and gambling devices.</li>
              <li>Perishable foodstuff</li>
              <li>Medicine</li>
              <li>Ceramic or glass items</li>
              <li>Asbestos</li>
              <li>Magnetised materials</li>
              <li>Division 1.1 Explosives (e.g., mines and nitroglycerine)</li>
              <li>Division 1.2 Explosives (e.g., rockets and warheads)</li>
              <li>Division 1.3 Explosives (e.g., smoke signals, projectiles and commercial fireworks)</li>
              <li>Division 1.5 Explosives (e.g., blasting agents)</li>
              <li>Division 1.6 Explosives</li>
              <li>Division 2.3 Toxic Gas</li>
              <li>Division 6.2 Infectious Substances</li>
              <li>Class 7 Radioactive Material including White I, Yellow II, Yellow III and fissile material</li>
            </ul>

            <h5>Restricted items from international shipping:</h5>
            <ul>
              <li>Class 3 Flammable Liquids</li>
              <li>Division 1.4 Explosives (e.g., airbags, small arms ammunition and model rocket motors)</li>
              <li>Division 2.2 Non-Flammable, Non-Toxic Gas</li>
              <li>Division 4.1 Flammable Solids</li>
              <li>Any transaction involving International Traffic in Arms Regulations (ITAR) or other commodities
                subject to import licenses</li>
              <li>Artwork, archeological artifacts and antiquities</li>
              <li>Biological agents, etiological agents, and hosts and vectors of human disease</li>
              <li>Class 8 Corrosives</li>
              <li>Class 9 Miscellaneous (e.g., self-inflating life rafts, lithium batteries and dry ice)</li>
              <li>Division 2.1 Flammable Gas</li>
              <li>Division 4.2 Spontaneously Combustible Flammable Solids</li>
              <li>Division 4.3 Dangerous When Wet Flammable Solids</li>
              <li>Division 5.1 Oxidizers</li>
              <li>Division 5.2 Organic Peroxides</li>
              <li>Division 6.1 Toxic Substances (solid or liquid)</li>
              <li>Flowers</li>
              <li>Fresh foodstuffs</li>
              <li>Gems, cut or uncut</li>
              <li>Hazardous materials/dangerous goods and radioactive materials</li>
              <li>Household goods and personal effects</li>
              <li>Lithium batteries:
                <ul>
                  <li>All lithium metal batteries</li>
                  <li>Lithium metal batteries are generally non-rechargeable and contain metallic lithium,</li>
                  <li>Loose lithium-ion batteries</li>
                  <li>Lithium-ion batteries do not contain metallic lithium and are rechargeable. These include power
                    banks, USB chargers etc.</li>
                </ul>
              </li>
              <li>Medical Devices – must verify that the accepting warehouse complies with state requirements/
                licensing/permits for distribution of medical devices</li>
              <li>Microchips, computer chips, microprocessors, central processing units (CPUs) and mobile telephones
              </li>
              <li>One-of-a-kind/irreplaceable articles such as artwork valued between US$250,000 and US$500,000 each and
                other single items valued at US$250,000 and higher</li>
              <li>Other perishables</li>
              <li>Pharmaceuticals</li>
              <li>Precious metals such as gold, silver and platinum in the form of scrap, dust, sulfides, residue,
                industrial preparations such as silver powder and silver termination paste, and jewelry</li>
              <li>Project cargo</li>
              <li>Retail tobacco products</li>
              <li>Tranquilizing guns and ammunition</li>

            </ul>

            <h5>AusPost (includes all the above)</h5>
            <ul>
              <li>Articles more than A$2,000 in value</li>
              <li>Packages above 20kg</li>
            </ul>

            <p>
              <strong>Country based: </strong> <a style="color: white;text-decoration: underline;"
                href="https://www.fedex.com/en-us/shipping/international-prohibited-items.html"
                target="_blank">https://www.fedex.com/en-us/shipping/international-prohibited-items.html </a>
            </p>
            <a style="color: white; text-decoration: underline;"
              href="https://www.fedex.com/content/dam/fedex/us-united-states/shipping/fedex-international-connect-country-region-specific-prohibited-and-restricted-items.pdf"
              target="_blank">
              https://www.fedex.com/content/dam/fedex/us-united-states/shipping/fedex-international-connect-country-region-specific-prohibited-and-restricted-items.pdf
            </a>
          </div>






        </div>










      </div>
    </div>
  </div>
</div>